// extracted by mini-css-extract-plugin
export default {"footer":"ui_footer__bXixK","column":"ui_column__87IOU","columnCenter":"ui_columnCenter__v7WS0","socials":"ui_socials__hyWgR"};